import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const Row = ({ children, tone }) => (
  <div className={`text-xs px-2 py-1.5 border-l-2 ${tone}`}>{children}</div>
);

export const CargrSyncReportDialog = ({ report, onClose }) => {
  if (!report) return null;
  const { to_update = [], corrected = [], already = [], cleared = [], stale = [], conflicts = [], unmatched_listings = [], unmatched_cars = [], listings_found = 0 } = report;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[80vh] overflow-y-auto sm:max-w-2xl" data-testid="cargr-sync-report-dialog">
        <DialogHeader>
          <DialogTitle>Συγχρονισμός αγγελιών car.gr</DialogTitle>
          <DialogDescription>
            Βρέθηκαν {listings_found} αγγελίες στη σελίδα του καταστήματος.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {to_update.length > 0 && (
            <div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#16A34A] font-bold mb-1">
                ✓ Ενημερώθηκαν ({to_update.length})
              </div>
              <div className="space-y-1">
                {to_update.map((m) => (
                  <Row key={m.car_id} tone="border-[#16A34A] bg-[#ECFDF5]">
                    <strong>{m.car_title} {m.car_year || ""}</strong> → αγγελία <span className="font-mono">{m.listing_id}</span>
                  </Row>
                ))}
              </div>
            </div>
          )}
          {corrected.length > 0 && (
            <div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#0055FF] font-bold mb-1">
                ↻ Διορθώθηκαν ({corrected.length})
              </div>
              <div className="space-y-1">
                {corrected.map((m) => (
                  <Row key={m.car_id} tone="border-[#0055FF] bg-[#EFF6FF]">
                    <strong>{m.car_title} {m.car_year || ""}</strong> — είχε λάθος αριθμό <span className="font-mono line-through text-[#9CA3AF]">{m.existing_listing_id}</span> → <span className="font-mono">{m.listing_id}</span>
                  </Row>
                ))}
              </div>
            </div>
          )}
          {already.length > 0 && (
            <div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#4B5563] font-bold mb-1">
                ✓ Επιβεβαιώθηκαν ({already.length})
              </div>
              <div className="space-y-1">
                {already.map((m) => (
                  <Row key={m.car_id} tone="border-black/20 bg-[#F9FAFB] text-[#4B5563]">
                    {m.car_title} {m.car_year || ""} · <span className="font-mono">{m.listing_id}</span>
                  </Row>
                ))}
              </div>
            </div>
          )}
          {cleared.length > 0 && (
            <div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#F59E0B] font-bold mb-1">
                Αφαιρέθηκε λάθος αριθμός ({cleared.length})
              </div>
              <div className="space-y-1">
                {cleared.map((m) => (
                  <Row key={m.car_id} tone="border-[#F59E0B] bg-[#FEF3C7]">
                    <strong>{m.car_title} {m.car_year || ""}</strong> — ο αριθμός <span className="font-mono">{m.listing_id}</span> ανήκει σε άλλο αυτοκίνητο και αφαιρέθηκε
                  </Row>
                ))}
              </div>
            </div>
          )}
          {stale.length > 0 && (
            <div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#E60000] font-bold mb-1">
                ⚠ Δεν βρέθηκαν στο κατάστημα ({stale.length})
              </div>
              <div className="space-y-1">
                {stale.map((m) => (
                  <Row key={m.car_id} tone="border-[#E60000] bg-[#FEF2F2]">
                    <strong>{m.car_title} {m.car_year || ""}</strong> — η αγγελία <span className="font-mono">{m.listing_id}</span> δεν υπάρχει πια στο κατάστημα (πιθανόν διαγράφηκε ή ανανεώθηκε με νέο αριθμό)
                  </Row>
                ))}
              </div>
            </div>
          )}
          {conflicts.length > 0 && (
            <div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#F59E0B] font-bold mb-1">
                ⚠ Δεν άλλαξαν ({conflicts.length})
              </div>
              <div className="space-y-1">
                {conflicts.map((m) => (
                  <Row key={m.car_id} tone="border-[#F59E0B] bg-[#FEF3C7]">
                    {m.car_title} {m.car_year || ""} — {m.reason || `έχει ήδη άλλον αριθμό (${m.existing_listing_id})`}
                  </Row>
                ))}
              </div>
            </div>
          )}
          {unmatched_cars.length > 0 && (
            <div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#E60000] font-bold mb-1">
                Αυτοκίνητα χωρίς αγγελία ({unmatched_cars.length})
              </div>
              <div className="space-y-1">
                {unmatched_cars.map((c) => (
                  <Row key={c.id} tone="border-[#E60000]/40 bg-[#FEF2F2] text-[#4B5563]">{c.title}</Row>
                ))}
              </div>
            </div>
          )}
          {unmatched_listings.length > 0 && (
            <div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#4B5563] font-bold mb-1">
                Αγγελίες που δεν ταίριαξαν ({unmatched_listings.length})
              </div>
              <div className="space-y-1">
                {unmatched_listings.map((l) => (
                  <Row key={l.listing_id} tone="border-black/15 bg-white text-[#4B5563]">
                    <span className="font-mono">{l.listing_id}</span> · {l.title || "—"}
                  </Row>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-end">
          <button onClick={onClose} className="px-4 py-1.5 text-xs bg-[#0A0A0A] text-white hover:bg-black/80" data-testid="cargr-sync-report-close">
            Εντάξει
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
